import NavHeader from "../shared/Nav-Header";
import { useNavigate } from "react-router-dom";
import styles from './social.module.css';
import socialImage1 from '../nav Components/images/social-1.png';

const Social = () => {
    const navigate = useNavigate();

    const handleGroupClick = () => {
        navigate('/groups');
    }
    const handleClubClick = () => {
        navigate('/clubs');
    }
    const handleChannelClick = () => {
        navigate('/channels');
    }
    return (
        <div >
            <NavHeader />
            <div className={styles.socialPage}>
                <img src={socialImage1} alt="Social" className={styles.socialBGImage} />
                 <h1 className={styles.socialPageHeading}>Social</h1>
                <div className={styles.socialInfo}>Welcome to Social!</div>
                <div className={styles.socialComponents}>
                <div className={styles.socialCards}>
                    <div className={`${styles.socialCard} ${styles.group}`} onClick={() => handleGroupClick()}>
                        Groups
                    </div>
                    <div className={`${styles.socialCard} ${styles.club}`} onClick={() => handleClubClick()}>
                        Clubs
                    </div>
                    <div className={`${styles.socialCard} ${styles.channel}`}onClick={() => handleChannelClick()}>
                        Channels
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
}
export default Social;